import { useEffect, type ReactNode } from "react";
import { useLocation } from "react-router-dom";
import SiteHeader from "./SiteHeader";
import SiteFooter from "./SiteFooter";

export default function PageShell({ children }: { children: ReactNode }) {
  const { pathname } = useLocation();

  useEffect(() => {
    if (!window.location.hash) window.scrollTo({ top: 0 });
  }, [pathname]);

  useEffect(() => {
    const onScroll = () => {
      if (window.scrollY > 700) document.body.classList.add("has-top");
      else document.body.classList.remove("has-top");
    };
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className="min-h-screen bg-background-100 flex flex-col">
      <SiteHeader />
      <main className="flex-1">{children}</main>
      <SiteFooter />
      <a
        href="#/"
        className="fixed bottom-6 right-6 z-40 grid place-items-center w-11 h-11 rounded-full bg-primary-600 text-background-50 opacity-0 pointer-events-none translate-y-2 transition-all duration-300 has-scroll-visible"
        aria-label="回到顶部"
        onClick={(e) => {
          e.preventDefault();
          window.scrollTo({ top: 0, behavior: "smooth" });
        }}
      >
        <i className="ri-arrow-up-line text-lg" />
      </a>
    </div>
  );
}